import { OptionsIcon } from "assets/icons/OptionsIcon";
import {
  showErrorToast,
  showSuccessToast,
} from "components/CustomAlerts/CustomToast";
import { ModalConfirm } from "components/ModalConfirm/ModalConfirm";
import { DiseñoCurricularI } from "interfaces/DiseñoCurricular";
import { Dropdown } from "react-bootstrap";
import { deleteDiseñoCurricular } from "services/diseñoCurricular";
import { getDocumentacionFile, openFile } from "services/normativas";

interface Props {
  elemento: DiseñoCurricularI;
  onClickEdit: (elemento: DiseñoCurricularI) => void;
  refreshTable: () => void;
  onClickShowDetail: (elemento: DiseñoCurricularI) => void;
}

export const DiseñosCurricularesRowActions = ({
  elemento,
  onClickEdit,
  onClickShowDetail,
  refreshTable,
}: Props) => {
  const handleDelete = async (id: string | number) => {
    try {
      await deleteDiseñoCurricular(id);
      showSuccessToast("¡El diseño curricular fue eliminado con éxito!");
      refreshTable();
    } catch (error: any) {
      console.log(error);
      showErrorToast("Error eliminando el diseño curricular:", error.message);
    }
  };

  const onClickVerDocumento = (id: string | number) => {
    getDocumentacionFile({ id, fileName: "" }).then((file) => {
      if (file) {
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      }
    });
  };

  return (
    <Dropdown className="acciones-dropdown | d-flex justify-content-center">
      <Dropdown.Toggle>
        <OptionsIcon />
      </Dropdown.Toggle>

      <Dropdown.Menu>
        {/* <Dropdown.Item
          onClick={() =>
            onClickVerDocumento(elemento.documentacionAdjunta[0].id)
          }
        >
          Ver documento
        </Dropdown.Item> */}

        <Dropdown.Item onClick={() => onClickShowDetail(elemento)}>
          Ver documentos
        </Dropdown.Item>

        <Dropdown.Item onClick={() => onClickEdit(elemento)}>
          Editar
        </Dropdown.Item>

        <ModalConfirm
          title="Eliminar diseño curricular"
          onConfirm={() => handleDelete(elemento.id)}
          message={
            <p>
              Estas por eliminar el diseño curricular {elemento.nombre} <br />
              <b>¿Querés realizar esta acción? Esta acción es irreversible.</b>
            </p>
          }
          renderButton={(handleShow: () => void) => (
            <Dropdown.Item onClick={handleShow}>Eliminar</Dropdown.Item>
          )}
        />
      </Dropdown.Menu>
    </Dropdown>
  );
};
